import {
    SHOW_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD,
    HIDE_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD,
    SHOW_SECOND_DIALOG,
  } from "../actions/action-type";
  
  const initialState = {
    isShowing: false,
    title: "",
    content: "",
    buttonLabel1: "",
    buttonLabel2: "",
    url: "",
    showSecondDialog: false, // State for the second dialog
  };
  
  const notificationManualPOUploadReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case SHOW_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD:
        console.log(payload)
        return {
          
          ...state,
          isShowing: true,
          title: payload.title,
          content: payload.content,
          buttonLabel1: payload.buttonLabel1,
          buttonLabel2: payload.buttonLabel2,
          url: payload.url,
          showButton1: payload.showButton1,
          showButton2: payload.showButton2
        };
      case HIDE_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD:
        return initialState;
  
        case SHOW_SECOND_DIALOG:
          return {
            ...state,
            showSecondDialog: true,
            title: payload.title,
            content: payload.content,
          };
  
      default:
        return state;
    }
  };
  
  export default notificationManualPOUploadReducer;